import Routes from 'routing/Routes'

const App = () => <div>{Routes()}</div>

export default App
